import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { createQueryParameterAction, modifyQueryParameterAction } from "../../actions";
import {
  TextField,
  Grid,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  Typography
} from "@material-ui/core";
import { getLocalizedString } from "@icarius-localization/strings";
import ButtonDialogAction from "@icarius-common/buttonDialogAction";
import { openSnackbarAction } from "@icarius-common/snackbar/actions";
import useHandleForm from "./useHandleForm";
import { getParamTypes, getListTypes, getRequiredTypes } from "../../selectors";
import TextFieldMultiline from "@icarius-common/textFieldMultiline";
import CustomNumberFormat from '@icarius-common/dynamicInputs/customNumberFormat';

const gridStyle = { height: 75, padding: "0px 10px" };

const QueryForm = (props) => {

  const { data, parameterCode, paramNumToUse, handleClose } = props;
  const dispatch = useDispatch();

  const paramTypes = useSelector(getParamTypes);
  const listTypes = useSelector(getListTypes);
  const requiredTypes = useSelector(getRequiredTypes);

  const create = (formData) => {
    dispatch(createQueryParameterAction(formData))
      .then((res) => res?.status === 200 && handleClose());
  }

  const modify = (formData) => {
    dispatch(modifyQueryParameterAction(formData))
      .then((res) => res?.status === 200 && handleClose());
  }

  const openValidationError = () => {
    dispatch(openSnackbarAction({ msg: getLocalizedString("invalidData"), severity: "error", duration: 10000 }));
  }

  const {
    formData,
    setFormValue,
    submit
  } = useHandleForm(data, parameterCode, paramNumToUse, create, modify, openValidationError);

  return (
    <Grid container item xs={12} direction="row" style={{ width: "95%", margin: "auto" }}>
      <Grid container item xs={12}>
        <Grid container item alignItems="center" xs={12} sm={6} md={4} style={gridStyle}> {/* codigo */}
          <TextField
            disabled
            fullWidth
            margin={"none"}
            label={getLocalizedString("queryCodeLong")}
            value={formData.queryCode}
          />
        </Grid>
        <Grid container item alignItems="center" xs={12} sm={6} md={4} style={gridStyle}> {/* nombre */}
          <TextField
            required
            fullWidth
            margin={"none"}
            label={getLocalizedString("parameterName")}
            value={formData.name}
            onChange={(e) => setFormValue(e.target.value, "name")}
            inputProps={{ maxLength: 254 }}
          />
        </Grid>
        <Grid container item alignItems="center" xs={12} sm={6} md={4} style={gridStyle}> {/* Tipo de parámetro */}
          <FormControl style={{ width: "100%" }}>
            <InputLabel required id={`label-param-type`}>{getLocalizedString("parameterType")}</InputLabel>
            <Select
              value={formData.paramType}
              labelId={`label-param-type`}
              id={`select-param-type`}
              onChange={(e) => setFormValue(e.target.value, "paramType")}
              margin={"none"}
            >
              {
                paramTypes && paramTypes.map(item => (
                  <MenuItem
                    className={"whiteText"}
                    key={item.key}
                    value={item.key}>
                    {item.value}
                  </MenuItem>
                ))
              }
            </Select>
          </FormControl>
        </Grid>
        <Grid container item alignItems="center" xs={12} style={{ padding: "20px 10px" }}> {/* sql */}
          <TextFieldMultiline
            required={formData.listType !== "-"}
            fullWidth
            label={getLocalizedString("sqlToGetValueListForParameter")}
            rows={25}
            helperText={getLocalizedString("sqlParameterHelperText")}
            margin={"none"}
            value={formData.sql}
            onChange={(e) => setFormValue(e.target.value, "sql")}
            inputProps={{ spellCheck: 'false' }}
          />
        </Grid>
        <Grid container item alignItems="center" xs={12} style={gridStyle}> {/* listType */}
          <FormControl style={{ width: "100%" }}>
            <InputLabel required id={`label-selector-type`}>{getLocalizedString("listSelectionType")}</InputLabel>
            <Select
              value={formData.listType}
              labelId={`label-selector-type`}
              id={`select-selector-type`}
              onChange={(e) => setFormValue(e.target.value, "listType")}
              margin={"none"}
            >
              {
                listTypes && listTypes.map(item => (
                  <MenuItem
                    className={"whiteText"}
                    key={item.key}
                    value={item.key}>
                    {item.value}
                  </MenuItem>
                ))
              }
            </Select>
            <Typography variant={"caption"} className={"whiteText"} style={{ marginLeft: 14, marginRight: 14 }}>
              {getLocalizedString("listSelectionTypeValidOnlyForParamsFromSQL")}
            </Typography>
          </FormControl>
        </Grid>
        <Grid container item alignItems="center" xs={12} sm={6} style={gridStyle}> {/* required */}
          <FormControl style={{ width: "100%" }}>
            <InputLabel required id={`label-required`}>{getLocalizedString("requiredParameter")}</InputLabel>
            <Select
              value={formData.required}
              labelId={`label-required`}
              id={`select-required`}
              onChange={(e) => setFormValue(e.target.value, "required")}
              margin={"none"}
            >
              {
                requiredTypes && requiredTypes.map(item => (
                  <MenuItem
                    className={"whiteText"}
                    key={item.key}
                    value={item.key}>
                    {item.value}
                  </MenuItem>
                ))
              }
            </Select>
          </FormControl>
        </Grid>
        <Grid container item alignItems="center" xs={12} sm={6} style={gridStyle}> {/* Número de orden del parámetro */}
          <TextField
            disabled
            fullWidth
            margin={"none"}
            label={getLocalizedString("parameterOrderNumber")}
            InputProps={{ inputComponent: CustomNumberFormat }}
            value={formData.paramNum}            
          />
        </Grid>
      </Grid>
      <Grid container item xs={12} justify={"flex-end"} alignItems="center" style={{ marginBottom: 35 }}>
        <ButtonDialogAction isAccept onClick={submit} text={getLocalizedString("save")} />
      </Grid>
    </Grid>
  );
}

export default QueryForm;
